import React from 'react';
import { Box, Divider, List, Paper, SxProps, Theme, Typography } from '@mui/material';

export const Heading3 = ({ children, sx }: { children: React.ReactNode; sx?: SxProps<Theme> }) => (
  <Typography variant="h3" sx={{ fontWeight: 400, mt: 10, ...sx }}>
    {children}
  </Typography>
);

export const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body1" sx={{ mt: 2 }}>
    {children}
  </Typography>
);

export const UnorderedList = ({ children, sx }: { children: React.ReactNode; sx?: SxProps<Theme> }) => (
  <List
    sx={{
      pl: 6,
      listStyleType: 'disc',
      '& .MuiListItem-root': {
        display: 'list-item',
      },
      ...sx,
    }}
  >
    {children}
  </List>
);

export const LegalCard = ({ children, title }: { children: React.ReactNode; title: string }) => (
  <Paper>
    <Box sx={{ p: 5 }}>
      <Typography variant="h2">{title}</Typography>
    </Box>
    <Divider />
    <Box sx={{ p: 5, maxWidth: { xs: '100%', md: '70%' } }}>{children}</Box>
  </Paper>
);
